const divFileList = {
  text: 'Delete',
  retry: 'Retry',
};

export default divFileList;
